module.exports = __webpack_public_path__ + "static/media/case-mobile.e21bb5d0.svg";